import { Modal } from "rsuite";
import { Button } from "../../../../components";

export default function DeleteEntryModal({ open, onClose, onDelete, deleting, entryToUpdate }) {

  function handleOnDelete() {
    if (onDelete) {
      onDelete();
    }
  }

  return (
    <Modal open={open} onClose={onClose} size="sm" data-testid="delete-entry-modal">
      <Modal.Header>
        <Modal.Title>Delete Entry</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete the entry for "{entryToUpdate?.childName}"?
        <br />
        This action cannot be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleOnDelete} appearance="primary" loading={deleting} disabled={deleting} text={"Delete"} data-testid={`delete-entry`} />
        <Button onClick={onClose} appearance="subtle" disabled={deleting} text="Cancel" color="blue" data-testid="cancel-delete-entry" />
      </Modal.Footer>
    </Modal>
  );
}
